export const flyTo = (coordinates, zoomLvl) => {
  window.map.flyTo({
    center: coordinates,
    zoom: zoomLvl,
    speed: 1,
  });
};

export const mapCenterPC = [76.91537388145935, 43.21269175727281];

export const changeLayerVisibility = (layer, isVisible) => {
  let visibility = isVisible;
  if (typeof isVisible === 'boolean') {
    if (!isVisible) {
      visibility = 'none';
    } else {
      visibility = 'visible';
    }
  }
  window.map.setLayoutProperty(layer, 'visibility', visibility);
};
